import { render, staticRenderFns } from "./CheckPermission.vue?vue&type=template&id=6c363ccc&"
import script from "./CheckPermission.vue?vue&type=script&lang=js&"
export * from "./CheckPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c363ccc')) {
      api.createRecord('6c363ccc', component.options)
    } else {
      api.reload('6c363ccc', component.options)
    }
    module.hot.accept("./CheckPermission.vue?vue&type=template&id=6c363ccc&", function () {
      api.rerender('6c363ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/CheckPermission.vue"
export default component.exports